angular.module('swapick')
.controller('ServicesCtrl', ServicesCtrl);


function ServicesCtrl($scope, DataService, $ionicScrollDelegate,
  initialLoaderManager, $q, $ionicHistory, $state, $stateParams,
  Entities, notifyManager, $ionicLoading, Purchase, $rootScope) {


  this.objects = [];
  this.meta = {};
  this.selectedServices = {};
  this.thanksMessage = null;

  Entities.waitForUser()
  .then((u)=>{
      this.user = u;
  })

  this.loadMore = () => {
    this.loading = true;
    //call again dataservice and push to the list
    return DataService.services.getList({
      limit:50, offset: this.objects.length})
    .then(items => {
      let newItems = _.filter(items, i=> i.pagamento == 'in-app');
      this.objects = this.objects.concat(newItems);
      this.meta = items.metadata;
      if(items.length){
        $ionicScrollDelegate.resize();
      }
      this.firstLoad = true;
      return items;
    })
    .finally(()=>{
      this.loading = false;
    })
    $scope.$broadcast('scroll.infiniteScrollComplete');
  }

  this.hasMoreToLoad = () =>{
    return this.meta.next;
  }



  //#TODO: check transaction id for android
  let saveBuyProduct = (product) => {
    return DataService.buyService
    .post({
        service : product.id,
        transaction_id : product.transaction.id
    })

  }

  let buyProduct = (product) => {
    return Purchase.orderProduct(product, saveBuyProduct);
  }


  this.buy = () => {
    //#todo: call some services for in-app
    let svcId = _.keys(this.selectedServices)[0];
    let product = _.find(this.products, s => s.id == svcId);

    $ionicLoading.show();

    buyProduct(product)
    .then(()=>{
      this.selectedServices = {};
      return notifyManager.success("Acquisto completato");
      this.thanksMessage = `Acquisto completato correttamente (${product.title})`;
    })
    .finally(()=>{
      $ionicLoading.hide();
    })

  }

  this.canBuy = () => {
    return _.keys(this.selectedServices).length;
  }

  this.cleanBut = (id) => {
    let o = { };
    o[id] = true;
    this.selectedServices = o;
    this.thanksMessage = null;
  }


  this.products = $rootScope.PURCHASE_PRODUCTS;
  this.loader = initialLoaderManager.makeLoader(()=>{
    if(!window.cordova){
      console.log("cannot setup store on browser");
      this.loadMore();
      return $q.when([]);
    }
    return Purchase.setup().then(products => {
      this.products = products;
      return products;
    });
  }, false);

  if(!Purchase.initialized){
    this.loader.load();
  }
  /*
  $scope.$on('$ionicView.beforeEnter', () => {

  });
  */

  /*
  $scope.$on('$ionicView.beforeEnter', () => {
    if(!this.objects.length){
      this.loader.load();
    }
  });
  */


}



// WEBPACK FOOTER //
// ./src/controllers/services-controller.js